import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AppSourceRequest } from '@hangar/shared';
import { linkAppSource, unlinkAppSource } from './endpointsSource';

/** `PUT` / `DELETE /apps/{id}/source`: the app lists (which carry `source`) and the launch forms are refreshed either way. */
export function useAppSourceMutations() {
  const qc = useQueryClient();
  const refresh = () => {
    void qc.invalidateQueries({ queryKey: ['apps'] });
    void qc.invalidateQueries({ queryKey: ['launch-form'] });
  };
  const link = useMutation({ mutationFn: (v: { appId: string; body: AppSourceRequest }) => linkAppSource(v.appId, v.body), onSettled: refresh });
  const unlink = useMutation({ mutationFn: (v: { appId: string }) => unlinkAppSource(v.appId), onSettled: refresh });
  return { link, unlink };
}
